import type { ReactNode } from 'react';
import { BrandingContext } from './branding-context';
import type { BrandingConfig } from '../model/types';

export function BrandingProvider({
  branding,
  children,
}: {
  branding: BrandingConfig;
  children: ReactNode;
}) {
  return (
    <BrandingContext.Provider value={branding}>
      {children}
    </BrandingContext.Provider>
  );
}
